import { Box, Container, Typography, Card, useTheme, Button, Stack, alpha, Divider } from '@mui/material';
import { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Context } from '../../context';
import Page from '../Page';
import AccountForm from '../account/AccountForm';
import logoutFill from '@iconify/icons-eva/log-out-fill';
import { Icon } from '@iconify/react';

export default function Account() {
  const theme = useTheme();
  const { user } = useContext(Context);
  const { userDetail } = user;
  
  return (
    <Page title="Account | ChargeMiles" sx={{ marginTop: { xs: "128px", md: "62px" }, minHeight: '100vh', pb: 10 }}>
      <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
        <Card sx={{ 
          boxShadow: (theme) => `0 0 4px 0 rgba(145,158,171,0.24), 0 24px 48px 0 rgba(145,158,171,0.24)`,
          borderRadius: 3,
          overflow: "hidden",
          transition: 'transform 0.2s',
          '&:hover': {
            transform: 'translateY(-4px)'
          }
        }}>
          {/* Header Gradient */}
          <Box
            sx={{
              background: `linear-gradient(135deg, var(--app-color) 0%, ${theme.palette.primary.dark} 100%)`,
              color: '#fff',
              p: { xs: 3, md: 4 },
              textAlign: 'center',
            }}
          >
            <Typography variant="h4" fontWeight={700} gutterBottom>
              My Account
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.85 }}>
              Manage your personal information and vehicle details
            </Typography>
          </Box>

          <Box sx={{ p: { xs: 2, md: 4 } }}>
            <AccountForm userDetail={userDetail} />
          </Box>
        </Card>
      </Container>
    </Page>
  );
}
